import React, { useRef } from 'react';
import { noop } from 'lodash';
import { useEnteredView } from '@fiverr-private/hooks';
import { Button } from '@fiverr-private/button';
import { ContactButtonDisplayComponent } from '../ContactButtonDisplayComponent';
import { useMonitoring } from '../../../../utils/monitoring/useMonitoring';
import { useFloatingChatTrigger } from '../../../../hooks/useFloatingChatTrigger';
import { FederatedSeller } from '../../../../types';
import { GigData } from '../../../../server/types/GigData';
import { AiBriefMenuItem } from './AiBriefMenuItem';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
import styles from './index.module.scss';

interface ContactOptionsProps {
    onContactClick: () => void;
    options: {
        priorInteraction?: boolean;
        source?: string;
        aiBriefInitialGenerationText?: string;
    };
    buttonCopy?: React.ReactNode;
    contactButtonProps?: Partial<React.ComponentProps<typeof Button>> & { onClick: () => void };
    renderTrigger?: () => React.ReactNode;
    seller: FederatedSeller;
    gigs: GigData[];
}

export const ContactOptions = ({
    onContactClick,
    options,
    buttonCopy,
    contactButtonProps,
    renderTrigger,
    seller,
    gigs,
}: ContactOptionsProps) => {
    const { fireImpressionEvents, Providers } = useMonitoring();
    const { isFloatingChatEnabled } = useFloatingChatTrigger();

    const observableRef = useRef(null);

    useEnteredView(observableRef, {
        threshold: 1,
        onEntered: () =>
            fireImpressionEvents({
                [Providers.BigQuery]: {
                    type: 'contact_me_button_shown',
                    element: {
                        type: 'contact_seller_only',
                        name: 'ai_brief_drawer',
                    },
                },
            }),
    });

    const customTrigger = renderTrigger ? renderTrigger() : null;

    return (
        <div ref={observableRef} style={{ width: 'inherit', height: 'inherit', display: 'flex' }}>
            <AiBriefMenuItem
                options={options}
                onContactClick={onContactClick}
                seller={seller}
                gigs={gigs}
                trigger={
                    customTrigger || (
                        <ContactButtonDisplayComponent
                            source={options.source || ''}
                            componentName="ContactButtonDisplayComponent"
                            buttonCopy={buttonCopy}
                            withGradient={isFloatingChatEnabled}
                            {...contactButtonProps}
                            onClick={contactButtonProps?.onClick || noop}
                        />
                    )
                }
            />
        </div>
    );
};
